import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "../../store";
import { editSiteType, postSiteType } from "../../slices/siteType";
import * as Yup from "yup";
import { Inputs } from "../formInputs";
import { Base } from "../base";

interface Props {
  close: () => void;
  onSave: () => void;
}

const AddEditSiteTypeForm: React.FC<Props> = (props) => {
  const { close, onSave } = props;
  const dispatch = useDispatch();
  const { siteType, status } = useSelector((store) => store.siteType);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSubmit = (values: any) => {
    if (siteType.id === 0) {
      dispatch(postSiteType(values)).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    } else {
      dispatch(editSiteType(values)).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    }
  };

  const updateAfterChanged = () => {
    close();
    if (xs) {
      onSave();
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        width: 300,
        borderRadius: "10px",
        padding: "15px",
      }}
    >
      <Formik
        initialValues={siteType}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        <Form noValidate>
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Field component={Inputs.Text} name="name" label="Site Type" />
            </Grid>
          </Grid>
          <Grid container direction={"row"} justifyContent={"space-between"}>
            <Grid>
              <Base.Button text="Cancel" type="secondary" onClick={close} />
            </Grid>
            <Grid>
              <Inputs.Submit
                isSubmitting={status === "loading"}
                text={"Save"}
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddEditSiteTypeForm;
